import classNames from 'classnames'
import i18next from 'i18next'
import React, { ReactNode, RefObject, TableHTMLAttributes } from 'react'
import { IconLoading } from '../icon-loading'
import { Text } from '../text/Text'
import styles from './index.module.css'

// Matches h-10 on body cells in index.module.css; virtualized tables size their spacer rows from it
export const tableSmallRowHeightPx = 40

export interface TableSmallProps extends TableHTMLAttributes<HTMLTableElement> {
  className?: string
  tableClassName?: string
  containerRef?: RefObject<HTMLDivElement | null> | undefined
  children: ReactNode
  shadow?: boolean
  containerStyle?: React.CSSProperties | undefined
  containerId?: string
  emptyStateEl?: ReactNode
  isLoading?: boolean
  showEmptyState?: boolean
  stickyHeaders?: boolean
  onContainerDragOver?: (e: React.DragEvent<HTMLDivElement>) => void
}

export const TableSmall = ({
  shadow,
  containerRef,
  children,
  className,
  tableClassName,
  containerStyle,
  containerId,
  emptyStateEl,
  showEmptyState,
  stickyHeaders,
  isLoading,
  onContainerDragOver,
  ...props
}: TableSmallProps) => {
  const containerClassName = classNames(styles.wrap, shadow && styles.shadow, className)

  return (
    <div
      id={containerId}
      onDragOver={onContainerDragOver}
      className={containerClassName}
      style={containerStyle}
      ref={containerRef}
    >
      <table {...props} className={classNames(tableClassName, stickyHeaders && styles.stickyHeaders)}>
        {children}
      </table>
      {isLoading ? (
        <div className="my-12 flex flex-col items-center">
          <IconLoading className="text-6xl" />
          <Text as="span" className="mt-4" textType="base">
            {i18next.t('glow.loading')}
          </Text>
        </div>
      ) : (
        showEmptyState && emptyStateEl
      )}
    </div>
  )
}
